import React from "react";
import { Result, Card } from "antd";
import { createGlobalStyle } from "styled-components";

import Header_title from "../controls/Header_title";
import Footer_last from "../controls/Footer_last";

const StyledForm = createGlobalStyle`
  .ant-form-item {
    margin-bottom: 5px;
  }
`;

const Research_guest = () => {
  return (
    <React.Fragment>
      <StyledForm />

      <Header_title tname={JSON.parse(localStorage.getItem("user"))} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          marginBottom: "45px"
        }}
      >
        <Card
          style={{
            width: 500,
            textAlign: "center",
            borderRadius: 15,
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
          }}
        >
          <Result
            status="403"
            title="ไม่มีสิทธิ์ใช้งานระบบ"
            subTitle="บัญชีของคุณสามารถเข้าใช้งานได้เฉพาะหน้า Dashboard เท่านั้น"
          />
        </Card>
      </div>

      <Footer_last />
    </React.Fragment>
  );
};

export default Research_guest;
